import React from "react";
import "./../styles/footer.css"; // Importando o CSS de Footer

// Importando as imagens
import facebookLogo from "../assets/images/icon-facebook-footer.png";
import instagramLogo from "../assets/images/icon-instagram-footer.png";
import linkedinLogo from "../assets/images/icon-linkedin-footer.png";
import youtubeLogo from "../assets/images/icon-youtube-footer.png";
import rssLogo from "../assets/images/icon-rss-footer.png";
import logoBranca from "../assets/images/logo_ficael_branco.png";
import isoCertificado from "../assets/images/iso_footer.png";

// Componente Footer
const Footer = () => {
  // Dados das redes sociais
  const socialMedias = [
    {
      id: "facebook",
      url: "https://www.facebook.com/",
      imgSrc: facebookLogo,
      altText: "Facebook",
    },
    {
      id: "instagram",
      url: "https://www.instagram.com/fficael",
      imgSrc: instagramLogo,
      altText: "Instagram",
    },
    {
      id: "linkedin",
      url: "https://www.linkedin.com/company/fficael/",
      imgSrc: linkedinLogo,
      altText: "LinkedIn",
    },
    {
      id: "youtube",
      url: "https://www.youtube.com/channel/UCDeX3fgjqi-MIWIa0ZoWtvw",
      imgSrc: youtubeLogo,
      altText: "YouTube",
    }
    // {
    //   id: "rss",
    //   url: "https://ficael.com/feed/",
    //   imgSrc: rssLogo,
    //   altText: "RSS Feed",
    // },
  ];

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Redes Sociais */}
        <ul className="social-medias">
          {socialMedias.map((social) => (
            <li key={social.id}>
              <a
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                className={social.id}
              >
                <img src={social.imgSrc} alt={social.altText} />
              </a>
            </li>
          ))}
        </ul>

        {/* Logos Centralizados */}
        <div className="center">
          <img
            src={logoBranca}
            alt="Logo Ficael"
            width="245"
            height="58.3"
          />
          <img
            id="sgs"
            src={isoCertificado}
            alt="Certificado ISO"
            width="65"
            height="62.83"
          />
        </div>

        {/* Direitos Autorais */}
        <div className="right">    
          <p> 2025 Ficael. Todos os direitos reservados.</p>
          <div>
            <a href="/about">Sobre Nós</a> | <a href="/contact">Contato</a> |{" "}
            <a href="/privacy">Política de Privacidade</a>
          </div>
         
        </div>
      </div>
    </footer>
  );
};

export default Footer;
